import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");

  useEffect(() => {
    const handleStorageChange = () => {
      setLang(localStorage.getItem("lang") || "en");
    };
    window.addEventListener("storage", handleStorageChange);
    const interval = setInterval(handleStorageChange, 500);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  return (
    <footer className="bg-[#1A1A1A] text-[#F5F0E8] py-14">

      <div className="max-w-7xl mx-auto px-6">

        {/* TOP */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12 text-center md:text-left">

          {/* LEFT */}
          <div className="flex flex-col items-center md:items-start gap-5">

           <Link to="/" className="inline-flex items-center">
  <div className="bg-white px-3 py-2 rounded-md shadow-sm inline-flex items-center gap-2">
    
    <img
      src="/logo.png"
      alt="Rigors"
      className="h-10 object-contain"
    />

    <span className="text-[18px] font-century text-[#1A1A1A]">
      RIGORS <span className="text-[#B08D57]">LLP</span>
    </span>

  </div>
</Link>
            <p className="text-white text-[14px] max-w-xs leading-relaxed">
              {lang === "en"
                ? "Insurance Advisory, Done Properly."
                : "专业保险咨询服务。"}
              <br />
             {lang === "en"
  ? "Advisory You Can Rely On."
  : "值得信赖的专业咨询"}
            </p>

          </div>

          {/* CENTER */}
          <div className="flex flex-col items-center md:items-start">

            <h4 className="text-[18px] text-[#F5F0E8] mb-4">
              {lang === "en" ? "Primary Nav" : "主要导航"}
            </h4>

            <ul className="space-y-2 text-[14px]">

              <li>
                <Link to="/about" className="hover:text-[#B08D57] transition">
                  {lang === "en" ? "About" : "关于我们"}
                </Link>
              </li>

              <li>
                <Link to="/services" className="hover:text-[#B08D57] transition">
                  {lang === "en" ? "Services" : "服务"}
                </Link>
              </li>

              <li>
                <Link to="/career" className="hover:text-[#B08D57] transition">
                  {lang === "en" ? "Careers" : "职业发展"}
                </Link>
              </li>

              <li>
                <Link to="/contact" className="hover:text-[#B08D57] transition">
                  {lang === "en" ? "Contact" : "联系我们"}
                </Link>
              </li>

            </ul>

          </div>

          {/* RIGHT */}
          <div className="flex flex-col items-center md:items-start">

            <h4 className="text-[18px] text-[#F5F0E8] mb-4">
              {lang === "en" ? "Contact" : "联系方式"}
            </h4>

           <div className="space-y-2 text-[14px] text-white text-center md:text-left leading-relaxed">

  <p>
    {lang === "en"
      ? "371 Alexandra Road, #05-11, Singapore 159963"
      : "新加坡亚历山德拉路371号 #05-11, 邮编159963"}
  </p>

  <p>
    juanna@rigors.com.sg
  </p>

  <p>
    +65 9686 1689
  </p>

</div>

          </div>

        </div>

        {/* DIVIDER */}
        <div className="border-t border-[#2a2a2a] pt-6">

  <p className="text-[12px] text-[#999999] leading-relaxed text-center max-w-6xl mx-auto">
    {lang === "en"
      ? "© 2026 Rigors LLP. All rights reserved. Rigors LLP is a licensed financial adviser under the Financial Advisers Act (Cap. 110) of Singapore. This website is for informational purposes only and does not constitute an offer or solicitation to purchase any insurance product. Products are offered through our appointed insurance company partners only."
      : "© 2026 Rigors LLP 版权所有。Rigors LLP 是根据新加坡《财务顾问法》（第110章）授权的持牌财务顾问。本网站仅供参考，不构成任何保险产品的要约或招揽。所有产品均通过我们指定的保险合作伙伴提供。"}
  </p>

</div>
      </div>

    </footer>
  );
};

export default Footer;